import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ToolsPage from './pages/ToolsPage';
import GetInvolvedPage from './pages/GetInvolvedPage';
import WhatsNextPage from './pages/WhatsNextPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import LabStories from './pages/LabStories';
import ExperimentationZonePage from './pages/ExperimentationZonePage';
import ExperimentationAcademyPage from './pages/ExperimentationAcademyPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import SearchResultsPage from './pages/SearchResultsPage';
import CareersPage from './pages/CareersPage';
import JobDetailPage from './pages/JobDetailPage';
import NotFoundPage from './pages/NotFoundPage';
import CustomCursor from './components/CustomCursor';
import CurtainTransition from './components/CurtainTransition';
import { TransitionProvider } from './context/TransitionContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <TransitionProvider>
        <CustomCursor />
        <ScrollToTop />
        <CurtainTransition>
          <div className="App">
            <Header />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about-us" element={<AboutPage />} />
              <Route path="/tools" element={<ToolsPage />} />
              <Route path="/get-involved" element={<GetInvolvedPage />} />
              <Route path="/whats-next" element={<WhatsNextPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/search" element={<SearchResultsPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/lab-stories" element={<LabStories />} />
              <Route path="/experimentation-academy" element={<ExperimentationAcademyPage />} />
              <Route path="/experimentation-zone" element={<ExperimentationZonePage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/careers" element={<CareersPage />} />
              <Route path="/careers/:slug" element={<JobDetailPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>

            <Footer />
            <ToastContainer position="top-right" autoClose={3000} />
          </div>
        </CurtainTransition>
      </TransitionProvider>
    </Router>
  );
}

export default App;